import type { ReactNode } from "react";

// // // //

export function CatalogStatChip({
    label,
    children,
}: {
    label: string;
    children: ReactNode;
}) {
    return (
        <div className="inline-flex items-center gap-2 rounded-full border bg-card px-3 py-1.5 select-none">
            <span className="text-sm text-muted-foreground">{label}</span>
            <span className="text-sm font-medium text-foreground leading-none tabular-nums">
                {children}
            </span>
        </div>
    );
}
